import BaseService from "./base.service";

class MocksService extends BaseService {
  get entity() {
    return "mocks";
  }

  checkAnswers(mockLogId, answers, calculateResults = true) {
    const ids = this.getBrowserIdOptions();
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`mocks/check`, {
          mockLogId: mockLogId,
          answers: answers,
          calculateResults: calculateResults,
          platform: ids.platform,
          fingerprint: ids.fingerprint,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
  pauseMock(mockLogId, answers) {
    const ids = this.getBrowserIdOptions();
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`mocks/pause`, {
          mockLogId: mockLogId,
          answers: answers,
          platform: ids.platform,
          fingerprint: ids.fingerprint,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
  continueMock(mockLogId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`mocks/continue`, { mockLogId: mockLogId })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  filterQuestions(filter) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`mocks/filter`, {
          include: "questions",
          mockId: filter.courses,
          topics: filter.topics,
          subjects: filter.subjects,
          content: filter.content,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
  startEventMock() {
    const ids = this.getBrowserIdOptions();
    return new Promise((resolve, reject) => {
      return this.request({ auth: false })
        .post(`mocks/start-event`, {
          platform: ids.platform,
          fingerprint: ids.fingerprint,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getCurrentResult() {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`event-mocks/current-result`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  startEventMockTest() {
    const ids = this.getBrowserIdOptions();
    return new Promise((resolve, reject) => {
      return this.request({ auth: false })
        .post(`test/mocks/start-event`, {
          platform: ids.platform,
          fingerprint: ids.fingerprint,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
  getEventMockTest(id = window.required(), parameters = {}) {
    const params = {
      ...parameters,
    };
    return new Promise((resolve, reject) => {
      return this.request()
        .get(`test/event-mocks/${id}`, { params })
        .then((response) =>
          resolve(this.responseWrapper(response, response.data.data)),
        )
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
  getEventMock(id = window.required(), parameters = {}) {
    const params = {
      ...parameters,
    };
    return new Promise((resolve, reject) => {
      return this.request()
        .get(`event-mocks/${id}`, { params })
        .then((response) =>
          resolve(this.responseWrapper(response, response.data.data)),
        )
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
  checkResult(mockLogId, answers, mockId, calculateResults = true) {
    const ids = this.getBrowserIdOptions();
    console.log("mockLogId", {
      mockLogId: mockLogId,
      answers: answers,
      mockId: mockId,
      calculateResults: calculateResults,
      platform: ids.platform,
      fingerprint: ids.fingerprint,
    });
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`mocks/create-result`, {
          mockLogId: mockLogId,
          answers: answers,
          mockId: mockId,
          calculateResults: calculateResults,
          platform: ids.platform,
          fingerprint: ids.fingerprint,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
  generateResult(user, result) {
    const ids = this.getBrowserIdOptions();
    return new Promise((resolve, reject) => {
      return this.request({ auth: false })
        .post(`mocks/get-result`, {
          user: user,
          result: result,
          platform: ids.platform,
          fingerprint: ids.fingerprint,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
}
export default new MocksService();
